import {XhrService} from "../ts/xhr.service";
import {appendScriptToDOM} from "./utilities/functions";
import {showModal, generateNewModal, closeModal} from "./modal";
import {getNewFlashmessage} from "./flashmessages";
import {initDatepickerWithAjax} from "./datepicker";
import {initSearchableSelect} from "../../../reusch_global/js/global/searchableSelect";

function sendFormApi(event) {
    event.preventDefault();

    let formEl = event.target;
    let ajax_fn = formEl.getAttribute("data-ajax-function");
    let loader_selector = formEl.getAttribute("data-ajax-loader");
    const submitBtn = event.submitter || null;

    // set loader
    if (loader_selector) {
        const loaderElements = document.querySelectorAll(loader_selector);
        loaderElements.forEach((loaderElement) => {
            //addLoadingClass(loaderEl);
        });
    }

    // create FormData
    let formData = new FormData(formEl);
    // append pressed button to the form
    if (event.submitter && event.submitter.getAttribute("name")) {
        formData.append(event.submitter.getAttribute("name"), event.submitter.getAttribute("value"));
    }

    // set loading state on the clicked submit button
    if (submitBtn) {
        submitBtn.classList.add('is-loading');
    }

    XhrService.generalAjaxCall(ajax_fn, formData, 'POST', 'json').then(response => {
        // read frontend actions from response (array or empty)
        const frontendActions = Array.isArray(response.frontendActions) ? response.frontendActions : [];
        if (!response.status) {
            throw "Unable to handle response from GeneralAjaxDataResponse";
        }

        // remove loading state; set success state for copy basket
        if (submitBtn) {
            submitBtn.classList.remove('is-loading');
            if (response.status === 'ok') {
                submitBtn.classList.add('is-success');
                // remove success state after 2 seconds
                window.setTimeout(() => {
                    submitBtn.classList.remove('is-success');

                    // Execute optional frontend actions globally, in given order, after success animation
                    if (frontendActions.length > 0) {
                        for (const action of frontendActions) {
                            switch (action) {
                                case 'close-modal':
                                    try { closeModal(); } catch (e) { /* noop */ }
                                    break;
                                case 'page-reload':
                                    // trigger reload and stop further processing
                                    return window.location.reload();
                                default:
                                    // unknown action – ignore silently
                                    break;
                            }
                        }
                    }
                }, 2000);
            }
        }

        for (const htmlToDom of response.htmlToDom) {
            let domTargets = document.querySelectorAll(htmlToDom.domTargetSelector);
            domTargets.forEach((domTargetSelector) => {
                domTargetSelector.innerHTML = htmlToDom.html;
            });
        }

        if (response.status === "error" && response.errorMessage !== "") {
            /*
            response.modalData = {
                "title": "",
                "text": response.errorMessage,
                "modalClasses": ["modal--error"]
            }
            */
        }

        if (response.modalData && response.modalData.html) {
            const title = response.modalData.title;
            const text = response.modalData.html;

            const MODAL_ID = 'ajax-response-modal';
            const modal = getOrCreateModal(MODAL_ID, 'modalTemplate');

            if (modal) {
                // Reset-Zustand, falls Modal bereits existierte
                modal.className = 'modal modal--loading';

                modal.classList.remove('modal--loading');

                for (const modalClass of response.modalData.modalClasses) {
                    modal.classList.add(modalClass);
                }

                const modalBody = modal.querySelector('.modal__body');
                const modalTitle = modal.querySelector('.modal__title');

                if (modalTitle) {
                    modalTitle.innerHTML = response.modalData.title || '';
                }

                if (modalBody) {
                    modalBody.innerHTML = `<div>${response.modalData.html}</div>`;
                }

                showModal(modal);
                initDatepickerWithAjax();
                initSearchableSelect(document);
            }
        }

        for (const scriptToDom of response.scriptToDom) {
            appendScriptToDOM(scriptToDom.scriptText, scriptToDom.addToBody);
        }


        for (const [messageType, listOfMessages] of Object.entries(response.flashMessages)) {
            // for type definition see SessionFlashMessageBag.php
            let mappingMessageTypToInt = {
                "info": 0,
                "notice": 0,
                "warning": 2,
                "error": 3,
                "success": 1,
            };
            let messageTypeInt = mappingMessageTypToInt[messageType];

            for (const message of listOfMessages) {
                getNewFlashmessage(message, messageTypeInt);
            }
        }

        return response.status;
    }).catch(() => {
        // ensure loading state is removed on errors
        if (submitBtn) {
            submitBtn.classList.remove('is-loading');
        }
    });

}

export function initAjaxFormApi() {
    document.addEventListener('submit', evt => {
        if (evt.target.classList.contains('js-ajaxFormSend')) {
            sendFormApi(evt);
        }
    });
}

function getOrCreateModal(modalId, templateId) {
    let modal = document.getElementById(modalId);

    if (modal) {
        // Modal existiert bereits → zurückgeben
        return modal;
    }

    // Modal existiert nicht → neu generieren
    modal = generateNewModal(templateId);

    if (!modal) {
        return null;
    }

    modal.id = modalId;
    return modal;
}